export default __webpack_public_path__ + "static/media/user-4.a6143582.png";